import { supabase } from './supabase';
import { uploadFile } from './storage-utils';
import { processStatusService } from '../services/supabase/process-status';

export async function transcribeAudio(
  blob: Blob, 
  userId: string,
  recordingType: 'meeting' | 'thought' = 'meeting'
) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    // Create a meeting record first
    const { data: meeting, error: meetingError } = await supabase
      .from('meetings')
      .insert({
        user_id: userId,
        title: `Recording ${new Date().toLocaleString()}`,
        status: 'processing',
        type: 'recording',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })
      .select()
      .single();

    if (meetingError) throw meetingError;

    // Initialize upload status
    await processStatusService.updateStatus(meeting.id, userId, 'upload', 'processing');

    // Initialize the subscription for this meeting
    processStatusService.subscribeToTranscriptionComplete(meeting.id, userId);

    // Use a single timestamp for the filename
    const timestamp = Date.now();
    const file = new File([blob], `${timestamp}.webm`, {
      type: blob.type,
    });

    // Upload to the appropriate bucket based on recording type
    const bucket = recordingType === 'meeting' ? 'recordings' : 'thoughts';
    console.log(`Uploading file to ${bucket} bucket...`);
    
    const uploadedFile = await uploadFile(file, userId, bucket);
    if (!uploadedFile) throw new Error('Failed to upload file');

    // Mark upload as completed
    await processStatusService.updateStatus(meeting.id, userId, 'upload', 'completed');

    console.log(`File uploaded successfully to path: ${uploadedFile.path}`);

    // Initialize transcription status
    await processStatusService.updateStatus(meeting.id, userId, 'transcription', 'processing');

    // Call the analysis function with the recording type
    const response = await fetch('/api/assemblyanalysis', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        recordingPath: uploadedFile.path,
        meetingId: meeting.id,
        userId: userId,
        recordingType: recordingType
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to process recording');
    }

    const result = await response.json();
    return result;
  } catch (error: any) {
    console.error('Transcription error:', error);
    throw error;
  }
}